import { Field } from "react-final-form";
import classNames from "classnames";

import Radio from "@components/Form/Radio";

const OwnerTypeSection = ({ values }) => (
  <div>
    <div className="text-sm font-medium mb-[10px]">
      Tip proprietar <span className="text-red-brand">*</span>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">
      <div
        className={classNames("flex items-center p-[16px] bg-white", {
          "border border-[#99CE88]": values?.legalType === "PF",
        })}
      >
        <Field
          name="legalType"
          type="radio"
          value="PF"
          component={Radio}
          label="Persoana fizica"
          className={classNames("cursor-pointer w-full mb-0", {
            "pointer-events-none cursor-default": values.legalType === "PF",
          })}
          labelClass="font-normal text-[14px]"
        />
      </div>

      <div
        className={classNames("flex items-center p-[16px] bg-white", {
          "border border-[#99CE88]": values?.legalType === "PJ",
        })}
      >
        <Field
          name="legalType"
          type="radio"
          value="PJ"
          component={Radio}
          label="Persoana juridica"
          className={classNames("cursor-pointer w-full mb-0", {
            "pointer-events-none cursor-default": values.legalType === "PJ",
          })}
          labelClass="font-normal text-[14px]"
        />
      </div>
    </div>
  </div>
);

export default OwnerTypeSection;
